import React, { Component } from 'react';

const AccesoSimultaneoItem = (props) => {
    return (
        <div className="text-configuration-view">
            <p className="begin">{props.message}:  </p>
            <p className="end">{props.value}</p>
        </div>
    );
};

export default AccesoSimultaneoItem;